/*!
 * Serialize all form data into an array
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
/**
 * @param form
 */
export function serializeArray(form) {
  // Setup our serialized data
  const serialized = {};

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i];

    // Don't serialize fields without a name, submits,
    // buttons, file and reset inputs, and disabled fields
    if (!field.name
      || field.disabled
      || field.type === 'file'
      || field.type === 'reset'
      || field.type === 'submit'
      || field.type === 'button') {
      // eslint-disable-next-line no-continue
      continue;
    }

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      const values = [];
      for (let n = 0; n < field.options.length; n++) {
        // eslint-disable-next-line no-continue
        if (!field.options[n].selected) continue;
        values.push(field.options[n].value);
      }
      serialized[field.name] = values;
      // eslint-disable-next-line brace-style
    }

    // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized[field.name] = field.value;
    }
  }

  return serialized;
}

/**
 *
 */
export function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}

/**
 * @param tagName
 * @param attributes
 * @param childrens
 */
export function e(tagName, attributes, children) {
  const element = document.createElement(tagName);

  if (typeof attributes === 'object') {
    Object.keys(attributes).forEach(i => {
      element.setAttribute(i, attributes[i]);
    });
  }
  if (typeof children === 'string') {
    element.textContent = children;
  } else if (children instanceof Array) {
    children.forEach(child => {
      element
        .appendChild(child);
    });
  }
  return element;
}

/**
 * @param amount
 */
export function addCommas(amount) {
  const x = amount.toString().split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? `.${x[1]}` : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1,$2');
  }
  return x1 + x2;
}

/**
 *
 */
export function getScrollTop() {
  let scrOfY = 0;
  if (typeof (window.pageYOffset) === 'number') {
    // Netscape compliant
    scrOfY = window.pageYOffset;
  } else if (document.body
    && (document.body.scrollLeft
      || document.body.scrollTop)) {
    // DOM compliant
    scrOfY = document.body.scrollTop;
  } else if (document.documentElement
    && (document.documentElement.scrollLeft
      || document.documentElement.scrollTop)) {
    // IE6 Strict
    scrOfY = document.documentElement.scrollTop;
  }
  return scrOfY;
}

export function addEventListeners(target, events, callback) {
  events.split(' ').forEach(event => target.addEventListener(event, callback, false));
}
